import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import AssignPhoneCallDialog, {
  AssignPhoneCallDialogCallbackInput,
  AssignPhoneCallUniqueProps,
} from '../AssignPhoneCallDialog';

const { useDialogForContext, useDialog: useAssignPhoneCallDialog } =
  getDialogHooks<
    AssignPhoneCallUniqueProps,
    AssignPhoneCallDialogCallbackInput
  >(AssignPhoneCallDialog);
export const useAssignPhoneCallDialogForContext = useDialogForContext;
export default useAssignPhoneCallDialog;
